import { useNavigate } from 'react-router-dom';
import * as S from './styles'
import { Button } from 'components/Button';
import { Dropdown } from 'components/Dropdown';
import { useEffect, useState } from 'react';
import { useAnyProvider } from 'hooks/Context';
import { useSpaProvider } from 'hooks/spaRouterContext';
import fetchAxios from 'services/http';
import { mapBuilding, mapGetProperties } from 'utils/formatterArray';
import { useQuery } from 'react-query';
import InputDate from 'components/InputDate';
import MobileCarouselProperties from 'components/MobileCarouselProperties';
import { NavBar } from 'components/NavBar';
import { AutoCompleteInput } from 'components/AutoCompletInput';
import { useHeader } from 'components/Header/useHeader';
import { useAutoCompletInput } from 'components/AutoCompletInput/useAutoCompletInput';
import { WhatsappButton } from 'components/WhatsappButton';
import { CalendarComponent } from 'components/Calendar';
const iconError = require('assets/svg/error/WarningError.svg').default

export const SearchMobile: React.FC = () => {

    const arrowBack = require('assets/svg/LeftArrow.svg').default;

    const searchIcon = require('../../../assets/svg/MagnifyingGlass.svg').default;

    const focusOnHeader = () => {
        setIsOpen(false)
    };

    const { searchValue, anyValue, date, setDate, guest } = useAnyProvider();

    const { pressEnterSelectOption } = useAutoCompletInput({ setSearch: (e: any) => checkInput(e), search: searchValue, isOpen: true })

    const navigate = useNavigate()

    const { carouselTitle, calendarRef, array, buildings, checkInput, closeCalendar, errorSearch, handleClickButton, handleHeaderClick, handleSelectQuantPeople, promotionalUnits, units, isOpen, setIsOpen, address, setErrorSearch } = useHeader();

    const { expanded, setPageChosen, pageChosen } = useSpaProvider();

    const separator = <p style={{ fontSize: 55, fontWeight: 100 }}>|</p>

    function filterPropertiesWithEmphasys(properties: Record<string, any>[]): Record<string, any>[] {
        return properties.filter(property => property.emphasys === true);
    }

    const fetchAccommodations = async () => {
        const { data } = await fetchAxios.post(`accommodations`, {
            "checkIn": "",
            "checkOut": "",
            "home": true
        });
        let mappedProperties = mapGetProperties(data.data);

        function filterPropertiesWithNonZeroUniqueValue(properties: Record<string, any>[]): Record<string, any>[] {
            return properties.filter(property => property.uniqueValue !== 0);
        }

        const propertiesWithNonZeroUniqueValue = filterPropertiesWithNonZeroUniqueValue(mappedProperties);
        let sortedProperties = propertiesWithNonZeroUniqueValue.sort((a, b) => a.uniqueValue - b.uniqueValue);

        let propertiesWithEmphasys = filterPropertiesWithEmphasys(propertiesWithNonZeroUniqueValue);
        let sortedPropertiesWithEmphasys = propertiesWithEmphasys.sort((a, b) => a.uniqueValue - b.uniqueValue);

        return {
            promotionalUnits: sortedProperties.slice(0, 9),
            units: sortedPropertiesWithEmphasys.slice(0, 9),
        };
    }


    const { data, isError, error } = useQuery('accommodations', fetchAccommodations)

    const fetchBuilding = async () => {
        const { data } = await fetchAxios.get(`accommodations/buildings/list`, {
            params: {
                home: true
            }
        });
        let mappedProperties = mapBuilding(data.data);
        return {
            buildings: mappedProperties.slice(0, 9),
        };
    }

    const { data: dataBuilding, isError: isErrorBuilding, isLoading: loadingBuilding, error: errorBuilding } = useQuery('accommodations/buildings/list', fetchBuilding)
    const order = [
        "Helbor Stay Batel",
        "All You Need",
        "7Th Avenue Live",
        "Studio do Bosque",
        "CWBe",
        "Vivance Batel",
        "BFF2211",
        "Hyde Park",
        "Edifício Milena",
    ];


    // const invalidSearch = (): boolean => {
    //   if (expanded === true) {
    //     return false
    //   }
    //   if (expanded === false) {
    //     if (searchValue !== '' && anyValue !== 'false') {
    //       return false
    //     }
    //   }
    //   return true
    // }


    function handleTitles(): string {
        switch (pageChosen) {
            case 0:
                return 'Apês em destaque'
            case 1:
                return 'Oportunidades para você'
            case 3:
                return 'Cidades mais procuradas'
            case 2:
                return 'Sugestões de unidades Yogha'
            default:
                return 'Em destaque'
        }
    }


    function handleCarousel(): any {
        switch (pageChosen) {
            case 0: {
                return <MobileCarouselProperties type='default' hasFrom card='unit' key={`carousel-${pageChosen}`} titleCarousel={carouselTitle} data={units} />;
            }
            case 1: {
                return <MobileCarouselProperties type='default' hasFrom card='unit' key={`carousel-${pageChosen}`} titleCarousel={carouselTitle} data={promotionalUnits} />;
            }
            case 2: {
                return <MobileCarouselProperties hasFrom type='unit' card='building' key={`carousel-${pageChosen}`} titleCarousel={carouselTitle} data={buildings} />;
            }
            // case 3: {
            //     return <MobileCarouselProperties hasFrom type='unit' card='building' key={`carousel-${pageChosen}`} titleCarousel={carouselTitle} data={buildings} />;
            // }
        }
    }


    const carousel = handleCarousel()


    const [isOpenAutoComplete, setIsOpenAutoComplete] = useState(false)

    const handleButtonClick = () => {
        if (searchValue === '') {
            setErrorSearch(true)
        } else {
            setErrorSearch(false)
            pressEnterSelectOption(new MouseEvent("click"))
        }
    };

    useEffect(() => {
        setDate([])
    }, [])

    return (
        <S.Container>
            <S.Header>
                <S.Back>
                    <img src={arrowBack} onClick={() => navigate(-1)} alt='Voltar página' />
                </S.Back>
                <h1>Escolha um lugar</h1>
            </S.Header>
            <S.ContainerModal>
                <div className='teste' style={{ display: 'flex', width: '100%', flexDirection: 'column', alignItems: 'center' }}>

                    <AutoCompleteInput isOpen={isOpenAutoComplete} setIsOpen={setIsOpenAutoComplete} expanded={expanded} widthDrop={'100%'} hasResult={'has'} onChange={() => { }} placeholder={'Busque por cidade, unidade, bairro...'} search={searchValue} setSearch={(e: any) => checkInput(e)} options={address} />
                    {
                        searchValue === '' && errorSearch === true && (
                            <div style={{ display: 'flex', width: '110%', flexDirection: 'row', gap: 4, marginTop: 4 }}>
                                <img src={iconError} alt="" />
                                <S.ErrorInput>Busque por um local</S.ErrorInput>

                            </div>

                        )
                    }

                </div>
                <CalendarComponent date={date} setDate={setDate} />

                <Dropdown guest={guest} expanded={!expanded} placeholder='Hóspedes' widthDrop={'100%'} onChange={(o) => handleSelectQuantPeople(o?.value)} type='dropdown' options={array} />


                <S.NavContainer>
                    <NavBar selected={pageChosen} setSelected={setPageChosen} />
                </S.NavContainer>
                <S.CarrouselContainer>
                    {carousel}
                </S.CarrouselContainer>
                <S.ButtonContainer>
                    <Button title='Buscar' icon={searchIcon} iconDirection='left' iconHeight={24} iconWidth={24} size='large' widthSize={'calc(100% + 30px)'} type='primary' disabled={false} onClickButton={() => handleButtonClick()} />
                </S.ButtonContainer>
            </S.ContainerModal>
            <WhatsappButton />
        </S.Container>
    )
}